"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiInternalError = exports.ManagementTypes = void 0;
var ManagementTypes;
(function (ManagementTypes) {
    ManagementTypes["COMMERCIAL"] = "commercial";
    ManagementTypes["RESEARCH"] = "research";
    ManagementTypes["TEST"] = "test";
    ManagementTypes["DEFUNCT"] = "defunct";
    ManagementTypes["DEFUNCT_RETRIEVE"] = "defunct-retrieve";
    ManagementTypes["DEFUNCT_ABANDON"] = "defunct-abandon";
})(ManagementTypes || (exports.ManagementTypes = ManagementTypes = {}));
class ApiInternalError extends Error {
    constructor(message, statusCode, extra) {
        super(message);
        this.name = 'ApiInternalError';
        this.statusCode = statusCode;
        this.extra = extra;
    }
}
exports.ApiInternalError = ApiInternalError;
//# sourceMappingURL=common.js.map